import { DefaultRouteTabs } from '@/components/_common';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import VehicleWithoutMovementForm from '@/components/Reports/MovementReports/VehicleWithoutMovementForm';
import { useVehiclesWithoutMovementReport } from '@/core/domain/reports/movements/vehicleWithoutMovements/vehicleWithoutMovements.hooks';
import {
  ReportVehicleWithoutMovementFormValues,
  VehiclesWithoutMovementRequest,
} from '@/core/domain/reports/movements/vehicleWithoutMovements/vehicleWithoutMovements.types';
import useFileLoading, { FILE_FORMAT, FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import { useReportHandlers } from '@/hooks/useReportHandler';
import { PageProps } from '@/types/PageProps';
import { DateTimeFormat } from '@/utils/moment';
import { Divider, Form } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function MovementVehicleWithoutMovementPage({
  route,
}: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<ReportVehicleWithoutMovementFormValues>();

  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const generateReport = useVehiclesWithoutMovementReport();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const { initialDate, finalDate, ...values } = await form.validateFields();

      const obj: VehiclesWithoutMovementRequest = {
        ...values,
        format: FILE_FORMAT[format],
        startDate: initialDate.format(DateTimeFormat),
        endDate: finalDate.format(DateTimeFormat),
      };

      const result = await generateReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const { handleView, handlePdf, handleCsv } = useReportHandlers(
    'relatório_de_veículos_sem_movimentação',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <VehicleWithoutMovementForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        generateCsv={handleCsv}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}
